import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Index from "./pages/Index";

const PlatformPage = lazy(() => import("./pages/PlatformPage"));
const FeaturesPage = lazy(() => import("./pages/FeaturesPage"));
const AdminDashboardPage = lazy(() => import("./pages/AdminDashboardPage"));
const TeacherAppPage = lazy(() => import("./pages/TeacherAppPage"));
const ParentAppPage = lazy(() => import("./pages/ParentAppPage"));
const StudentPortalPage = lazy(() => import("./pages/StudentPortalPage"));
const PricingPage = lazy(() => import("./pages/PricingPage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const BlogPage = lazy(() => import("./pages/BlogPage"));
const BlogPostPage = lazy(() => import("./pages/BlogPostPage"));
const GoogleAdsLandingPage = lazy(() => import("./pages/GoogleAdsLandingPage"));
const RegisterSchoolPage = lazy(() => import("./pages/DealLandingPage"));
const NotFound = lazy(() => import("./pages/NotFound"));
const SitemapPage = lazy(() => import("./pages/SitemapPage"));
const PrivacyPolicyPage = lazy(() => import("./pages/PrivacyPolicyPage"));
const TermsAndConditionsPage = lazy(() => import("./pages/TermsAndConditionsPage"));
const SchoolManagementAddisAbabaPage = lazy(() => import("./pages/SchoolManagementAddisAbabaPage"));
const MultiInstituteAddisAbabaPage = lazy(() => import("./pages/MultiInstituteAddisAbabaPage"));

const ClientSiteRoutes = () => (
  <Routes>
    <Route path="/" element={<Index />} />
    <Route path="/platform" element={<PlatformPage />} />
    <Route path="/features" element={<FeaturesPage />} />
    <Route path="/admin-dashboard" element={<AdminDashboardPage />} />
    <Route path="/teacher-app" element={<TeacherAppPage />} />
    <Route path="/parent-app" element={<ParentAppPage />} />
    <Route path="/student-app" element={<StudentPortalPage />} />
    <Route path="/pricing" element={<PricingPage />} />
    <Route path="/about" element={<AboutPage />} />
    <Route path="/contact" element={<ContactPage />} />
    <Route path="/school-management-system-ethiopia" element={<GoogleAdsLandingPage />} />
    <Route path="/school-management-in-addis-ababa" element={<SchoolManagementAddisAbabaPage />} />
    <Route path="/multi-institute-system-addis-ababa" element={<MultiInstituteAddisAbabaPage />} />
    <Route path="/register-school" element={<RegisterSchoolPage />} />
    <Route path="/blog" element={<BlogPage />} />
    <Route path="/blog/:slug" element={<BlogPostPage />} />
    <Route path="/sitemap" element={<SitemapPage />} />
    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
    <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default ClientSiteRoutes;
